import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-112" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-113" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-blue-900 text-gold-300" data-id="element-114" data-mp="2223lxxjryni5">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-115" data-mp="1x54op64te0fq" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-116" data-mp="19faekwbvqpz6">
          Garantía 7 días
        </h2>

        <div className="mt-9 rounded-2xl bg-blue-50 px-6 py-9 ring-1 ring-blue-100 md:px-10" data-id="element-117" data-mp="1j52d21n3o38x">
          <p className="font-display text-2xl font-extrabold tracking-tight text-blue-600 md:text-3xl" data-id="element-118" data-mp="1ee3qwlffkaxr">
            Si no es lo que esperabas, te devolvemos el 100%
          </p>
          <p className="mt-6 text-lg text-ink md:text-xl" data-id="element-119" data-mp="qlwtrk1vrzxa">
            Descargás los tomos. Los usás en casa por 7 días. Si no es lo que prometimos, devolución
            completa sin preguntas, sin drama.
          </p>
        </div>

        <p className="mt-6 text-sm text-blue-900/55" data-id="element-120" data-mp="txt6athq29a8">Tasa de devoluciones: menos del 1%.</p>
      </div>
    </section>;
}